import { Receipt } from "lucide-react";
import { useEffect, useState } from "react";

import BlocoRecolhivel from "./BlocoRecolhivel";
import Chave from "./Chave";

const API_URL = process.env.REACT_APP_BACKEND_URL || "";
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem("token") || ""}`, "Content-Type": "application/json" });

// Um switch por módulo (pedido do dono, 21/10/2026): ex.: Chiquinho Carnes não
// quer cupom no Balcão. Mesmos módulos do cupom de preparo.
const MODULOS = [
  { chave: "Mesas", nome: "Mesas", detalhe: "inclui o pedido pelo QR da mesa" },
  { chave: "Comandas", nome: "Comandas", detalhe: "conta em nome do cliente, sem mesa" },
  { chave: "Balcao", nome: "Balcão" },
  { chave: "Totem", nome: "Totem" },
  { chave: "Delivery", nome: "Delivery", detalhe: "sem o cupom de entrega, o motoboy sai sem o papel do pedido" },
  { chave: "Cardapio", nome: "Cardápio", detalhe: "pedidos do cardápio digital" },
  { chave: "iFood", nome: "iFood" },
];
const TODOS = Object.fromEntries(MODULOS.map((m) => [m.chave, true]));

/** Liga/desliga, por módulo, o cupom de fechamento (caixa/entrega) que sai
 *  sozinho na venda. Botões de imprimir, 2ª via e cupom com nota fiscal não
 *  são afetados. Quem descarta é o servidor, então vale para todo computador. */
export default function FechamentoPreferencias({ toast }) {
  const [modulos, setModulos] = useState(null); // null = carregando
  useEffect(() => {
    fetch(`${API_URL}/api/settings/fechamento`, { headers: auth(), cache: "no-store" })
      .then((r) => (r.ok ? r.json() : {}))
      .then((d) => setModulos({ ...TODOS, ...(d.modulos || {}) }))
      .catch(() => setModulos(TODOS));
  }, []);

  const alternar = async (m) => {
    const anterior = modulos;
    const novo = !modulos[m.chave];
    setModulos({ ...modulos, [m.chave]: novo });
    try {
      const r = await fetch(`${API_URL}/api/settings/fechamento`, { method: "PUT", headers: auth(), body: JSON.stringify({ modulos: { [m.chave]: novo } }) });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.detail || "Não foi possível salvar.");
      setModulos({ ...TODOS, ...(d.modulos || {}) });
      toast({ title: `Cupom de fechamento do ${m.nome} ${novo ? "ligado" : "desligado"}` });
    } catch (e) {
      setModulos(anterior);
      toast({ title: "Erro ao salvar", description: e.message, variant: "destructive" });
    }
  };

  const ligadosN = modulos ? MODULOS.filter((m) => modulos[m.chave]).length : 0;
  const resumo = !modulos ? "Carregando…" : ligadosN === MODULOS.length ? "Ligado em todos os módulos" : `Ligado em ${ligadosN} de ${MODULOS.length} módulos`;
  return (
    <BlocoRecolhivel e2e="card-fechamento-modulos" icone={Receipt} titulo="Imprimir cupom de fechamento" resumo={resumo} carregando={!modulos}>
      <p className="text-sm text-muted-foreground">
        O cupom de caixa (fechamento, entrega) que sai sozinho quando a venda é feita. Desligado, aquele módulo não imprime
        o cupom automaticamente. Os botões de imprimir, a 2ª via e o cupom com nota fiscal continuam imprimindo.
      </p>
      <p className="mt-2 text-xs text-muted-foreground">
        No Delivery, desligado significa que o motoboy sai sem o cupom de entrega.
      </p>
      <div className="mt-4 grid gap-x-6 sm:grid-cols-2" data-e2e="fechamento-modulos">
        {MODULOS.map((m) => (
          <div key={m.chave} className="flex items-center justify-between gap-3 py-2 border-t">
            <div className="min-w-0">
              <p className="text-sm font-medium">{m.nome}</p>
              {m.detalhe && <p className="text-xs text-muted-foreground">{m.detalhe}</p>}
            </div>
            <Chave ligado={modulos?.[m.chave]} onAlternar={() => alternar(m)} desabilitado={!modulos} id={`sw-fechamento-${m.chave}`} />
          </div>
        ))}
      </div>
    </BlocoRecolhivel>
  );
}
